import { Link } from "@material-ui/core"
import { StyledULItem } from "common/UnorderedList"
import styled from "styled-components"
import { Font } from "../wizard/constants"

const notes = [
  'המחיר כולל מע"מ ואגרת רישוי',
  "התמונה להמחשה בלבד",
  "רכישת הרכב בכפוף לחתימה על הסכם הזמנה ותשלום המלא על פיה",
  <>
    תוקף ההטבות למשך 7 ימי עסקים ומותנה בחתימה על{" "}
    <Link href="/מאזדה_נספח_הזמנה_דוגמא.pdf" target="_blank" color="primary">
      הסכם הזמנה
    </Link>
  </>,
  <>
    אחריות לרכב – כמפורט ב
    <Link
      href="https://www.mazda.co.il/%D7%90%D7%97%D7%A8%D7%99%D7%95%D7%AA/%D7%A9%D7%99%D7%A8%D7%95%D7%AA"
      target="_blank"
      color="primary"
    >
      תנאי האחריות
    </Link>
  </>,
]

const StyledNotes = styled.ul`
  list-style-type: none;
  padding: 0;
`
const StyledNote = styled(StyledULItem)`
  font-family: ${Font.OENaPro};
  font-size: 12px;
  font-weight: 300;
  line-height: 20px;
  letter-spacing: 0em;
`

type LegalNotesProps = {
  className?: string
}

const LegalNotes = ({ className }: LegalNotesProps) => (
  <StyledNotes className={className}>
    {notes.map((note, i) => (
      <StyledNote key={i}>
        <span>{note}</span>
      </StyledNote>
    ))}
  </StyledNotes>
)

export default LegalNotes
